// extracted by mini-css-extract-plugin
module.exports =  {"description":"rdKjC7YUNm_ANIlbZIHX","title":"wOxS2D1NEi7nKt4AuRXI"};